import React from 'react'
import { Link } from 'react-router-dom';
import { BiLogoGmail } from 'react-icons/bi'
import { FaFileSignature, FaPhone } from 'react-icons/fa6'
import EmailUsForm from 'components/forms/EmailUsForm';

const ContactUsContent = () => {
    const iconStyle = 'self-center mr-2 lg:mx-4 text-3xl lg:text-5xl text-secondary';

    return (
        <div className='space-y-8'>
            <div className='text-center text-3xl font-bold'>GET STARTED NOW</div>
            <div className='flex items-center flex-col lg:flex-row space-y-8 lg:space-x-8'>
                <div className='w-full space-y-6'>
                    <p>We don’t sell your information, you will get a response from  Insurance Enterprise</p>
                    <ul className='space-y-4'>
                        <li className='flex md:items-center'>
                            <div className='min-w-10 lg:min-w-20'>
                                <FaPhone className={iconStyle} />
                            </div>
                            <div className='flex flex-col md:flex-row'>
                                <p className='mr-2'>Phone:</p>
                                <a href="tel:8883506605" rel='noreferrer' className='text-secondary'>(888) 350-6605</a>
                            </div>
                        </li>
                        <li className='flex md:items-center'>
                            <div className='min-w-10 lg:min-w-20'>
                                <BiLogoGmail className={iconStyle} />
                            </div>
                            <div className='flex flex-col md:flex-row'>
                                <p className='mr-2'>Email:</p>
                                <Link to="mailto:benefits@insuranceenterpriseusa.com" className='text-secondary hover:no-underline break-all'>benefits@insuranceenterpriseusa.com</Link>
                            </div>
                        </li>
                        <li className='flex items-center'>
                            <div className='min-w-10 lg:min-w-20'>
                                <FaFileSignature className={iconStyle} />
                            </div>
                            <Link className='text-secondary' to='/agent'>Apply</Link> &nbsp;To Become A Sales Agent.</li>
                    </ul>
                </div>
                <div className='w-full flex justify-center'>
                    <EmailUsForm />
                </div>
            </div>
        </div>
    )
}

export default ContactUsContent